import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import {
  createSubjectsAndBankLinesReconcilation,
  ReconcilableResponse,
} from '../../paymentReconciliationModal/query-api'

interface UseCreateSubjectsAndBankLinesReconciliationProps {
  onError?: (error?: APIError) => void
  onSuccess?: (data: ReconcilableResponse) => void
}

export const useCreateSubjectsAndBankLinesReconciliation = (
  props: UseCreateSubjectsAndBankLinesReconciliationProps,
) => {
  const { onError, onSuccess } = props || {}

  const {
    mutate: create,
    mutateAsync: createAsync,
    isLoading: isProcessing,
    ...rest
  } = useMutation(createSubjectsAndBankLinesReconcilation, {
    onSuccess,
    onError,
  })

  return { create, createAsync, isProcessing, ...rest }
}
